import React, { useContext, useEffect, useState, useRef } from "react";
import {
  Wrapper,
  Container,
  LogoWrapper,
  Heading,
  SubHeading,
  Input,
  Button,
  LinkButton,
  Offer,
} from "./SignInOutForm.style";
import { FormattedMessage } from "react-intl";
import { AuthContext } from "../../contexts/auth/auth.context";
// import Image from 'components/Image/Image';
// import PickBazar from '../../image/PickBazar.png';
import { connect } from "react-redux";
import { doPasswordRequest, resetmessages } from "../../store/actions/authAction";
import * as Constants from "../../constants/Constant";
import axios from "axios";
import Loader from "../../components/Loader/Loader";
import { Weight } from "../Cart/CartItem/CartItem.style";
import t from '../../i18n/translate';
import { Tab, Tabs } from "react-bootstrap";
import { Email, Smartphone } from "@material-ui/icons";
import ReCAPTCHA from "react-google-recaptcha";
import CloudflareTurnstile from "../../components/CloudflareTurnstile";

const lang = localStorage.getItem("lang");

const ForgotPassModal = (props) => {
  const { authDispatch } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [errormsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [authType, setAuthType] = useState("phone");
  const [token, setToken] = useState(null);
  const captcha = useRef(null);

  const toggleSignInForm = () => {
    authDispatch({
      type: "SIGNIN",
    });
  };
  const handleVerify = (token) => {
    setToken(token);
  }

  const findUserByEmailOrPhone = (identifier) => {
    axios
    .post(Constants.baseUrl+`api/checkUserExistByEmailOrPhone?_locale=${lang}`, {
        identifier: identifier,
      })
      .then(function (response) {
        if (response.data.status === 2) {
          setLoading(false);
          setError(true);
          setErrorMsg(t("login_error_not_registered"));
        }
        else{
          setError(false);
          setErrorMsg("");
          props.doPasswordRequest({ identifier: identifier, recaptchaToken: token });
          setTimeout(() => {
            setLoading(false);
          }, 2000);
        };
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        if(error?.response?.data){
          setError(true);
          setErrorMsg(error.response.data?.message);
          return false;
        }
      });
  }

  const validateEmail = () => {
    setLoading(true);
    if (!email || email === "") {
      setErrorMsg(t('forget_password_error_empty_email_or_phone', false));
      setError(true);
      setLoading(false);
    }
    // else if ((Constants.email_reg.test(email)) === false) {
    //   setErrorMsg(t('forget_password_error_invalid_email', false));
    //   setError(true);
    // }
    else {
      if (!token) {
        setLoading(false);
        alert("Please complete the captcha below.");
        return 
      }
      if (authType === "phone") {
        if (/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(email) === false) {
          setError(true);
          setErrorMsg(t('login_error_incorrect_phone'));
          setLoading(false);
        } else {
          setError(false);
          setErrorMsg("");
          findUserByEmailOrPhone(email);
        }
      } else {
        if ((Constants.email_reg.test(email)) === false) {
          setErrorMsg(t('login_error_incorrect_email'));
          setError(true);
          setLoading(false);
        } else {
          setError(false);
          setErrorMsg("");
          findUserByEmailOrPhone(email);
        }
      }
      // setError(false);
    }
  };
  const forgetCallback = async (e) => {
    e.preventDefault();
    validateEmail();
  };
  useEffect(() => {
    return ()=>{
      setLoading(false);
      setError(false);
      setErrorMsg("");
      props.resetmessages();
    };
  }, []);
  useEffect(() => {
    if (props.passwordrequest && email !== "" ) {
      setLoading(false);
      authDispatch({ type: "RESETPASS" });
      // document.getElementById("resetpass").disabled = false;
    }
  }, [props.passwordrequest, email]);

  const handleSelectTab = (e) => {
    setAuthType(e);
    setEmail("");
    setErrorMsg("");
    setError(false);
    props.resetmessages();
  };

  return (
    <Wrapper>
      <Container style={{ paddingBottom: 30 }}>
        {/* <LogoWrapper>
          <Image url={PickBazar} />
        </LogoWrapper> */}

        <Heading className={props.cartType}>
          { t('forget_password_title') }
        </Heading>

        <SubHeading>
          { t('forget_password_description') }
        </SubHeading>
        <form onSubmit={forgetCallback} style={{ display: "flex", flexDirection: "column",}}>
          <Tabs defaultActiveKey="phone" id="forget-pass-tab" className={`${props.cartType === "express" ? "express" : ""}`} justify onSelect={(e) => handleSelectTab(e)}>
            <Tab eventKey="phone" title={<div className="d-flex align-items-center justify-content-center"><Smartphone className="mr-1" />{t("auth_type_phone_title")}</div>}>
              <Input
                type="text"
                className={props.cartType}
                placeholder={ t('login_input_phone_title', false) }
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                onBlur={()=>{}}
              />
            </Tab>
            <Tab eventKey="email" title={<div className="d-flex align-items-center justify-content-center"><Email className="mr-1" />{t("auth_type_email_title")}</div>}>
              <Input
                type="text"
                className={props.cartType}
                placeholder={ t('login_input_email_title', false) }
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                onBlur={()=>{}}
              />
            </Tab>
          </Tabs>
          {error &&
            <>
              <span style={{color: "red", marginBottom: "10px"}} >{errormsg}&nbsp; {
                errormsg.includes("registered yet") ? <span onClick={(e) => {
                  e.preventDefault();
                  authDispatch({
                    type: "SIGNUP",
                  });
                  }} 
                  style={{color: props.cartType === 'express' ? "#f01266" : "#9cc54b", textDecoration: "underline", fontWeight: "700", cursor: "pointer"}}>{ t('forgot_password_register_link') }
                    </span> : null
              }
              </span>
            </>
          }
          {props.resetmessage !== "" && props.resetmessage !== "Not registered" &&
             <>
              <span style={{color: "red", marginBottom: "10px"}} >{props.resetmessage} &nbsp;
              </span> 
             </>
          }

          {/*<ReCAPTCHA*/}
          {/*  sitekey={Constants.captchaKey}*/}
          {/*  ref={captcha}*/}
          {/*  onChange={() => captcha.current.getValue()}*/}
          {/*/>*/}
          <div className={"d-flex"} style={{backgroundColor:"#ffffff"}}>
            <CloudflareTurnstile
                sitekey={Constants.sitekey}
                onVerify={(token) => handleVerify(token)}
                onError={(error) => console.log(error)}
                className="turnstile-widget"
                style={{ backdropColor:"#ffffff" }}
            />
          </div>
          <Button
            id={"resetpass"}
            fullwidth
            title={ t('forget_password_button_reset_password', false) }
            intlButtonId="resetPasswordBtn"
            style={{ color: "#fff", fontWeight: "normal", fontSize: '1rem', marginTop: "10px" }}
            type="submit"
            disabled={loading}
            loader={<Loader />}
            isLoading={loading}
          />
        </form>
        <Offer style={{ padding: "20px 0 0" }}>
          { t('forget_password_button_back_to') }
          <LinkButton className={props.cartType} onClick={toggleSignInForm}>
            { t('forget_password_login_link') }
          </LinkButton>
        </Offer>
      </Container>
    </Wrapper>
  );
};
const mapStateToProps = (state) => {
  return {
    success: state.authReducer.success,
    showOtp: state.authReducer.showOtp,
    passwordrequest: state.authReducer.passwordrequest,
    resetmessage: state.authReducer.resetmessage,
    cartType: state.cartReducer.cartType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doPasswordRequest: (body) => doPasswordRequest(body, dispatch),
    resetmessages: () => resetmessages(dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassModal);
